import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';

import {
  connect,
  ApiResponseHelper,
} from 'omni-common-ui';

import { actions as progressTestActions } from 'data/ProgressTests';
import { actions as progressReportsActions } from 'data/ProgressReports';
import {
  actions as studentReportSummariesActions,
} from 'data/ProgressReports/StudentReportSummaries';
import {
  actions as progressTestsPlanActions,
  getDefaultProgressReportId,
 } from 'data/ProgressTestsPlan';

class ProgressReport extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // triggered on first load
  componentWillMount() {
    this._fetchProgressTestAndReportModels();
    this._redirectToProgressReportList(this.props);
  }

  // triggered on PT navigation
  componentWillReceiveProps(nextProps) {
    this._fetchProgressTestAndReportModels(nextProps);
    this._redirectToProgressReportList(nextProps);
  }

  _redirectToProgressReportList(props) {
    const { groupId, defaultProgressReportId, buildRoute, replace } = props;
    if (! defaultProgressReportId) return;
    if (props.location.pathname.endsWith('unit-report')) {
      replace(buildRoute(
        `/group/${groupId}` +
        `/unit-report/${defaultProgressReportId}`
      ));
    }
  }

  _fetchProgressTestAndReportModels(props = this.props) {
    const {
      progressTest,
      progressReports,
      studentReportSummaries,
      currentProgressTestId: progressTestId,
      currentProgressReportId: progressReportId,
    } = props;
    const { groupId } = props.params;
    props.fetchProgressTestPlanIfNeeded(groupId);
    if (! progressReportId) return;
    if (ApiResponseHelper.shouldFetch(studentReportSummaries)) {
      props.fetchStudentReportSummaries(progressReportId);
    }
    if (ApiResponseHelper.shouldFetch(progressReports)) {
      props.fetchProgressReport(groupId);
    } else if (ApiResponseHelper.hasSucceeded(progressReports) &&
        ApiResponseHelper.shouldFetch(progressTest)) {
      props.fetchProgressTest(groupId, { id: progressTestId });
    }
  }

  render() {
    const {
      progressTest,
      progressReport,
      progressReports,
      params,
    } = this.props;

    if (! progressReport ||
        ! progressReports.data ||
        ! progressTest ||
        ! progressTest.data ||
        ! params.progressReportId) {
      return null;
    }
    return <div>
      <div className={styles.ProgressReport_content}>
        {this.props.children}
      </div>
    </div>;
  }
}

function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const group = state.get('rootReducer').get('groups').get(groupId).data;
  const progressReports = group.get('progressReports');
  const defaultProgressReportId = getDefaultProgressReportId(state, groupId);
  if (! defaultProgressReportId) return;
  let currentProgressReportId = ownProps.params.progressReportId;
  if (! currentProgressReportId) {
    currentProgressReportId = getDefaultProgressReportId(state, groupId);
  }
  const studentReportSummaries =
      state.get('rootReducer').get('studentReportSummaries').get(currentProgressReportId);
  let progressTest;
  let progressReport;
  let currentProgressTestId;

  if (ApiResponseHelper.hasSucceeded(progressReports)) {
    progressReport = progressReports.data.get(currentProgressReportId);
    currentProgressTestId = progressReport.progressTestId;
    progressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);
  }

  return {
    groupId,
    groupName: group.name,
    currentProgressTestId,
    defaultProgressReportId,
    currentProgressReportId,
    progressReports,
    progressReport,
    progressTest,
    studentReportSummaries,
    params: ownProps.params,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(progressTestActions, dispatch),
    bindActionCreators(progressReportsActions, dispatch),
    bindActionCreators(studentReportSummariesActions, dispatch),
    bindActionCreators(progressTestsPlanActions, dispatch)
  );
}

ProgressReport.getCurrentRouteSegment = (props) =>
  props.routes[props.routes.length - 1];

ProgressReport.propTypes = {
  children: PropTypes.node,
  progressReports: PropTypes.object.isRequired,
  progressReport: PropTypes.object,
  progressTest: PropTypes.object,
  fetchProgressTest: PropTypes.func.isRequired,
  fetchProgressReport: PropTypes.func.isRequired,
  fetchStudentReportSummaries: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressReport);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/component.jsx